import { styled } from 'libs/ui/styled';

export const ContentStyled = styled('div')(({ theme }) => ({
  marginBottom: 4,

  [theme.breakpoints.down('mobile')]: {
    marginBottom: 16,
  },
}));
